import Enums from "../components/enums";

class AddressSortingAndFilteringPaging {
  static sortAndFilterAddressesPaging(
    sortOrder,
    addressFilter,
    addresses,
    numberOfAddressesRendered,
    currentAddress
  ) {
    return new Promise(function (resolve, reject) {
      let sortedAndFilteredAddresses = addresses.filter((a) => {
        let name = a.businessName ? a.businessName : a.name;

        if (!name) {
          name = "";
        }

        return (
          name.toUpperCase().includes(addressFilter.toUpperCase()) ||
          a.street.toUpperCase().includes(addressFilter.toUpperCase())
        );
      });

      if (sortOrder !== Enums.SortOrder.None) {
        var sortOrderNameFirst;
        var sortOrderNameSecond;

        sortedAndFilteredAddresses.sort((a, b) => {
          sortOrderNameFirst = (a.businessName || a.name).toUpperCase();
          sortOrderNameSecond = (b.businessName || b.name).toUpperCase();
          return sortOrderNameFirst.localeCompare(sortOrderNameSecond);
        });

        if (sortOrder === Enums.SortOrder.Descending) {
          sortedAndFilteredAddresses.reverse();
        }
      }
      const renderedAddresses = sortedAndFilteredAddresses.splice(
        0,
        numberOfAddressesRendered
      );
      let inCurrentRenderedList = false;
      if (currentAddress) {
        if (!inCurrentRenderedList) {
          for (let i = 0; i < renderedAddresses.length; i++) {
            if (
              renderedAddresses[i].id.toString() ===
              currentAddress.id.toString()
            ) {
              renderedAddresses.splice(i, 1);
              renderedAddresses.unshift(currentAddress);
              inCurrentRenderedList = true;
              break;
            }
          }
        }
      }

      if (!inCurrentRenderedList && currentAddress) {
        renderedAddresses.unshift(currentAddress);
      }
      resolve(renderedAddresses);
    });
  }
}

export default AddressSortingAndFilteringPaging;
